module.exports = __webpack_public_path__ + "static/media/apply-succ.b90c2eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/apply-succ.svg
// module id = 248
// module chunks = 0